import { Add01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { ButtonBase, IconButton, useTheme } from '@mui/material';
import './MediaFilled.scss';

interface MediaFilledProps {
  title: string;
  description: string;
  price: string | React.ReactNode;
  image?: string;
  onClick?: () => void;
}

const MediaFilled = ({
  title,
  description,
  price,
  image,
  onClick,
}: MediaFilledProps) => {
  const theme = useTheme();

  return (
    <ButtonBase
      className="dish dish--media-filled"
      onClick={onClick}
      style={{ backgroundImage: `url(${image})` }}
      component="div"
    >
      <div className="dish__body">
        {title ? <h3 className="dish__title">{title}</h3> : null}
        {description ? (
          <p className="dish__description">{description}</p>
        ) : null}
        {price ? <p className="dish__price">{price}</p> : null}
        <div className="dish__actions">
          <IconButton
            className="dish__btn-details"
            onClick={onClick}
            sx={{ backgroundColor: theme.palette.primary.main }}
          >
            <HugeiconsIcon icon={Add01Icon} className="dish__btn-icon" color="white" />
          </IconButton>
        </div>
      </div>
    </ButtonBase>
  );
};
export default MediaFilled;
